// @ts-nocheck
import React from 'react';
import cx from 'classnames';
import css from './css';

interface Props {
  children: React.ReactNode;
  primary?: boolean;
  secondary?: boolean;
  info?: boolean;
  warning?: boolean;
  success?: boolean;
  danger?: boolean;
  error?: boolean;
  alignCenter?: boolean;
}

const Alert = (props: Props) => {
  const classes = cx(
    props.primary && styles.primary,
    props.secondary && styles.secondary,
    props.info && styles.info,
    props.warning && styles.warning,
    props.success && styles.success,
    props.danger && styles.danger,
    props.error && styles.danger,
    props.alignCenter && styles.alignCenter,
  ) || styles.primary;

  return (
    <div className={cx(styles.container, classes)}>
      {props.children}
    </div>
  );
};

const styles = css({
  container: {
    padding: '1rem',
    borderRadius: '0.25rem',
    border: '1px solid transparent',
    marginBottom: '1rem',
    maxHeight: 100,
    overflow: 'auto',
  },

  primary: {
    color: '#004085',
    backgroundColor: '#cce5ff',
    borderColor: '#b8daff !important',
    textAlign: 'left',
  },

  secondary: {
    color: '#383d41',
    backgroundColor: '#e2e3e5',
    borderColor: '#d6d8db !important',
  },

  info: {
    color: '#0c5460',
    backgroundColor: '#d1ecf1',
    borderColor: '#bee5eb !important',
  },

  warning: {
    color: '#856404',
    backgroundColor: '#fff3cd',
    borderColor: '#ffeeba !important',
  },

  success: {
    color: '#155724',
    backgroundColor: '#d4edda',
    borderColor: '#c3e6cb !important',
  },

  danger: {
    color: '#ba2a2a',
    backgroundColor: '#FDE4E4',
  },

  alignCenter: {
    textAlign: 'center',
  },
});

export default Alert;
